import { API_BASE_URL } from "@/config";
import { BaseService } from "@/services/base-service";
import { CsrfService } from "@/services/csrf/csrf-service";
import type { SubmitResponsesOutput } from "@amzn/hardware-self-service-api-model";
import type {
  HssStatusResponse,
  SubmitResponsesRequest,
} from "./hardware-self-service.types";

export class HardwareSelfServiceService extends BaseService {
  private readonly csrfService: CsrfService;

  constructor(csrfService: CsrfService = new CsrfService()) {
    super(API_BASE_URL);
    this.csrfService = csrfService;
  }

  public async getStatus(): Promise<HssStatusResponse> {
    const response = await this.fetch("/hss/status");
    if (!response.ok) throw new Error(`HSS API error: ${response.status}`);
    return await response.json();
  }

  public async submitResponses(
    request: SubmitResponsesRequest
  ): Promise<SubmitResponsesOutput> {
    const csrfToken = await this.csrfService.getToken();
    const response = await this.fetch("/hss/responses", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-csrf-token": csrfToken,
      },
      body: JSON.stringify(request),
    });
    if (!response.ok) throw new Error(`HSS API error: ${response.status}`);
    return await response.json();
  }
}
